export default __webpack_public_path__ + "static/media/beer-club-banner.8c6bfc36.png";